import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'

export class DeletePkRateApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/deleteRate',
      requesterInfo,
    })
  }

  public async deleteRate(guid: string): Promise<string> {
    this.props.url = `${this.props.url}?guid=${encodeURIComponent(guid)}`
    return await this.deleteAsync<string>()
  }
}
